export default function createRenderDataCache(label, div, zoomLevel) {
    return {
        text: label.text,
        layout: label.layout,
        div,
        zoomLevel
    };
}
